$('.click--down').click(function () {
    if ($(this).hasClass('down')) {
        $(this).parent().find('.accordion--slide').slideDown();
        $(this).addClass('up').removeClass('down');
    } else {
        $(this).parent().find('.accordion--slide').slideUp();
        $(this).addClass('down').removeClass('up');
    }
});

// $('.show--more').click(function(e){
//     e.preventDefault();
//     $(this).addClass('hide--link');
//     $(this).next('.show--more--text').slideDown();
// })
// $('.show--less').click(function(e){
//     e.preventDefault();
//     // $(this).addClass('hide--link');
//     // $(this).next('.show--more--text').slideDown();
//     $(this).parent('.show--more--text').slideUp();
//     $(this).parent('.show--more--text').prev('.show--more').removeClass('hide--link');
// })
function footerAccordion() {
    if ($(window).width() < 640) {
        $('.mobile--acc').click(function () {
            if ($(this).hasClass('mobile--acc--open')) {
                $(this).removeClass('mobile--acc--open');
                $(this).next('.mobile--acc--expand').slideUp();
            } else {
                $(this).addClass('mobile--acc--open');
                $(this).next('.mobile--acc--expand').slideDown();
            }
            
        });
    }
}


$(document).ready(function () {
    footerAccordion();

    $(window).resize(function () {
        footerAccordion();
    });
});






$('.card--image--wrapper').hover(function(){
    window.dispatchEvent(new Event('resize'));
})